export var tags = ['a', 'abbr', 'b', 'blockquote', 'button', 'caption', 'cite', 'code', 'div', 'em', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'i', 'label', 'li', 'link', 'ol', 'option', 'p', 'pre', 'small', 'span', 'strong', 'td', 'textarea', 'th', 'thead', 'u', 'ul'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/react-lion/es/components/tags.js
// module id = 627
// module chunks = 0